var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_html.js
// module id = 108
// module chunks = 1